module.exports = __webpack_public_path__ + "static/img/tf03.c11432d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tf03.png
// module id = xIJB
// module chunks = 0